/* Mobile two-tier post date + modInfo tap-to-copy (v6, locked 2026-08-18).
   Companion to the <=479px CSS in _posting.scss and the <table class="modInfo">
   markup in cells/op.njk / cells/post.njk / posting.js postCellTemplate.

   What it does — ALL NO-OPS ON DESKTOP (gated on matchMedia 479px):
     1. COMPACT (default): rewrites each .labelCreated to "MM/DD HH:MM"
        (year kept only when not the current year). The engine serves UTC
        "MM/DD/YYYY HH:MM:SS"; with the default convertLocalTimes setting,
        posting.addLocalTime has already rewritten it to local
        "YYYY-MM-DD HH:MM:SS" — both formats are parsed, so either order of
        execution renders the same moment.
     2. VERBOSE (opt-in body.verboseDate, settings key added in settings.js):
        date on its own line (CSS) as "Mon MM/DD/YYYY HH:MM:SS" + a relative
        hint ("Xh ago"/"Xd ago") ONLY for posts <1 week old (locked decision).
     3. TAP-TO-COPY: tapping a modInfo table row copies the field's value to
        the clipboard and flashes " ✓" (.copied, CSS in _posting.scss).

   WHY DYNAMIC (delegation + observer): posts are NOT all in the initial HTML —
   posting.addPost() injects new cells at runtime (thread auto-refresh) and
   fills .labelCreated via api.formatDateToDisplay (a THIRD format:
   "MM/DD/YYYY (Mon) HH:MM:SS"). So:
     - tap-to-copy is ONE document-level delegated click handler;
     - the date pass re-runs on a debounced body MutationObserver, catching
       live posts and any late text changes.

   Full precision is never lost: the original string is captured in
   data-full before the first rewrite, and postingMenu.js prefers it for the
   Post Menu's .postMenuDate row (full date stays one tap away in both modes).

   External file (like postBurger.js) -> NO inline <script> -> no CSP re-hash. */
(function () {
  'use strict';

  var mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 479px)') : null;
  var WEEK_MS = 7 * 24 * 60 * 60 * 1000;
  var HOUR_MS = 60 * 60 * 1000;
  var DAY_MS = 24 * 60 * 60 * 1000;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Parse whatever text format .labelCreated currently holds into an epoch ms:
       A: MM/DD/YYYY HH:MM:SS        raw server string (UTC) — convertLocalTimes off
       B: YYYY-MM-DD HH:MM:SS        after posting.addLocalTime (the default view)
       C: MM/DD/YYYY (Mon) HH:MM:SS  live posts pre-local-conversion (api.formatDateToDisplay)
     Returns null for anything unrecognised -> caller leaves the element alone. */
  function parseCreated(text) {
    var t = (text || '')
        .replace(/\([A-Z][a-z]{2}\)/, ' ')      // drop "(Mon)" if present (format C)
        .replace(/\s+/g, ' ').trim();
    var m;
    if ((m = t.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/))) {
      return Date.UTC(+m[3], +m[1] - 1, +m[2], +m[4], +m[5], +m[6]);
    }
    if ((m = t.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/))) {
      return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime();
    }
    return null;
  }

  /* Locked scope: hint only for posts <1 week old. Reuses the same lang keys
     (dAgo/hAgo with __value__) as posting.addRelativeTime. */
  function relativeHint(epoch) {
    var delta = Date.now() - epoch;
    if (delta < 0 || delta >= WEEK_MS) return '';
    var key, val;
    if (delta >= DAY_MS) { key = 'dAgo'; val = Math.round(delta / DAY_MS); }
    else { key = 'hAgo'; val = Math.max(1, Math.round(delta / HOUR_MS)); }
    if (typeof lang === 'undefined' || !lang[key]) return '';
    return lang[key].replace('__value__', String(val));
  }

  function renderDate(el) {
    /* First pass: capture the full original + absolute moment. Idempotent after.
       The rendered signature (mode|hint) makes repeat passes DOM-NO-OPs, which
       also breaks any observer feedback loop: no write -> no mutation -> stop. */
    var verbose = document.body.classList.contains('verboseDate');
    if (!el.dataset.epoch) {
      var epoch = parseCreated(el.textContent);
      if (epoch === null) return;               // unknown format — never blank it
      el.dataset.full = el.textContent.trim();  // Post Menu keeps full precision
      el.dataset.epoch = String(epoch);
    }
    var hint = relativeHint(+el.dataset.epoch);
    var sig = (verbose ? 'v' : 'c') + '|' + hint;
    if (el.dataset.rendered === sig) return;   // nothing changed — skip the write
    var d = new Date(+el.dataset.epoch);
    var now = new Date();
    var sameYear = d.getFullYear() === now.getFullYear();
    var base = pad(d.getMonth() + 1) + '/' + pad(d.getDate());
    /* OP posts: date only (no time) — saves line width on the busiest status lines
       (operator 2026-08-19). Full precision stays one tap away in the Post Menu.
       Replies keep the time (shorter lines have room). Verbose mode shows full
       precision for both, so this branch only affects compact + OP. */
    var isOP = el.closest ? !!el.closest('.innerOP') : false;
    if (verbose) {
      /* .weekday span: the verbose CSS in _posting.scss styles it separately
         (bolder); keep markup and CSS in lockstep. */
      var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      el.textContent = '';
      var wd = document.createElement('span');
      wd.className = 'weekday';
      wd.textContent = weekdays[d.getDay()];
      el.appendChild(wd);
      el.appendChild(document.createTextNode(' ' + base + '/' + d.getFullYear()
          + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())));
      if (hint) {
        var span = document.createElement('span');
        span.className = 'relhint';
        span.textContent = hint;
        el.appendChild(span);
      }
    } else if (isOP) {
      el.textContent = base + (sameYear ? '' : '/' + d.getFullYear());
    } else {
      el.textContent = base + (sameYear ? '' : '/' + d.getFullYear())
          + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    }
    el.dataset.rendered = sig;
  }

  function datePass() {
    if (!mobileMedia || !mobileMedia.matches) return;   // desktop keeps engine text
    document.querySelectorAll('.labelCreated').forEach(renderDate);
  }

  /* --- modInfo tap-to-copy (staff rows: Bypass / IP(+BR,NR) / ASN) --- */
  function copyText(text, done) {
    var ok = false;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { ok = true; done(ok); },
            function () { fallbackCopy(text, done); });
        return;
      }
    } catch (e) { /* fall through */ }
    fallbackCopy(text, done);
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    ta.remove();
    done(ok);
  }

  function onModInfoTap(e) {
    if (!mobileMedia || !mobileMedia.matches) return;   // desktop table: no tap-to-copy
    var tr = e.target.closest ? e.target.closest('table.modInfo tr') : null;
    if (!tr || tr.classList.contains('panelRealIp')) return;  // never-filled row
    var td = tr.querySelector('td');
    if (!td) return;
    var value = (td.textContent || '').replace(/\s+/g, ' ').trim();
    if (!value) return;                                  // empty field: nothing to copy
    e.preventDefault();
    copyText(value, function (ok) {
      tr.classList.add('copied');
      setTimeout(function () { tr.classList.remove('copied'); }, ok ? 1200 : 400);
    });
  }

  var passTimer = null;
  function schedulePass() {
    if (passTimer) clearTimeout(passTimer);
    passTimer = setTimeout(datePass, 80);
  }

  function init() {
    datePass();
    /* Catch live posts (posting.addPost rewrites .labelCreated) and any late
       text changes; also re-hints when verbose mode toggles at runtime. */
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if ((t && t.nodeType === 1
              && (t.classList.contains('labelCreated') || t.closest('table.modInfo')))
            || (muts[i].addedNodes && muts[i].addedNodes.length)) {
            schedulePass();
            return;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('click', onModInfoTap);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
